import React, { Component } from 'react'

// redux 
import { connect } from 'react-redux'
import ReportActions from '../../redux/component_select_report/actions'

// lib
import { Row } from 'antd'

// sub component
import ReportComponent from './report_component'

class ListReports extends Component{
    render(){
        const { reports } = this.props
        return (
            <div className="ListReport">
                {
                    reports.map((report, index) => {
                        return <ReportComponent report={report} key={index} />
                    })
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        reports: state.component_select_report.reports
    }
}

const mapDispatchToProps = dispatch => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ListReports)